// @noflow
import { deviceCapabilities, deviceControlModes, deviceTypes } from '~/core/constants/devices';

import { flowRight, last, split } from 'lodash/fp';
import { scheduleType } from '~/core/constants/schedule';

export const getScheduleType = (product = {}) => {
    const { type, props, state } = product;
    const truthMap = {
        [type === deviceTypes.ACTIVE_PLUG]: scheduleType.ACTIVE_PLUG,
        [type === deviceTypes.COLOR_TUNEABLE_LIGHT]: scheduleType.COLOUR_TUNEABLE_LIGHT,
        [type === deviceTypes.COLOR_LIGHT]: scheduleType.COLOUR_LIGHT,
        [type === deviceTypes.HEATING]: scheduleType.HEATING,
        [type === deviceTypes.HOT_WATER]: scheduleType.HOT_WATER,
        [type === deviceTypes.NA_THERMOSTAT &&
        (state.controlMode === deviceControlModes.COOL ||
            props.capabilities.includes(deviceCapabilities.COOL))]: scheduleType.NA_THERMOSTAT_COOL,
        [type === deviceTypes.NA_THERMOSTAT &&
        state.controlMode === deviceControlModes.AUTO]: scheduleType.NA_THERMOSTAT_DUAL,
        [type === deviceTypes.NA_THERMOSTAT &&
        (state.controlMode === deviceControlModes.HEAT ||
            props.capabilities.includes(deviceCapabilities.HEAT))]: scheduleType.NA_THERMOSTAT_HEAT,
        [type === deviceTypes.TUNEABLE_LIGHT]: scheduleType.TUNEABLE_LIGHT,
        [type === deviceTypes.WARM_WHITE_LIGHT]: scheduleType.WARM_WHITE_LIGHT
    };

    if (!truthMap[true]) {
        console.error(`Schedule type ${type} not found`);
    }

    return truthMap[true];
};

const separator = '__';

export const getDataIdFromComponent = flowRight(last, split(separator));

export const createComponentId = (instanceId, dataId) => `${instanceId}${separator}${dataId}`;

export const actionFormDataId = 'action-form';
export const actionFormComponentId = createComponentId('action', actionFormDataId);



// WEBPACK FOOTER //
// ./src/core/utils/schedule/index.js